import type { Client } from '@src/clients/domain/Client';
import { useNavigateBack } from '@src/common/hooks/useNavigateBack';
import { useToast } from '@src/common/hooks/useToast';
import { ClientsNavigation } from '@src/routing/ClientsNavigation';
import type { TrailerListing } from '@src/trailer/domain/TrailerList';
import { useUpdateTrailer } from '@src/trailer/hooks/useUpdateTrailer';
import { TrailerPageContent } from '@src/trailer/TrailerPageContent';
import { useTranslation } from 'react-i18next';

type Props = {
  client: Client;
  trailer: TrailerListing;
};

export const EditTrailerPage = ({ client, trailer }: Props) => {
  const { t } = useTranslation();
  const { goBack } = useNavigateBack({
    defaultPath: ClientsNavigation.get.url(client.id, 4),
  });

  const { showSuccessToast, showErrorToast } = useToast();

  const { updateTrailer, isLoading } = useUpdateTrailer({
    clientId: client.id,
    trailer,
    onSuccess: () => {
      showSuccessToast(t('editTrailerSuccess', { number: trailer.unitNumber }));
      goBack();
    },
    onError: () => {
      showErrorToast(t('editTrailerError', { number: trailer.unitNumber }));
    },
  });

  return (
    <TrailerPageContent
      client={client}
      onSubmit={updateTrailer}
      onCancel={goBack}
      onBack={goBack}
      isLoading={isLoading}
      prefillData={trailer}
    />
  );
};
